import { NgIf } from '@angular/common'
import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core'
import { ActivatedRoute, Router, RouterLinkActive } from '@angular/router'
import { NgIcon, provideIcons } from '@ng-icons/core'
import { heroFolder } from '@ng-icons/heroicons/outline'
import { KENDO_BUTTONS } from '@progress/kendo-angular-buttons'
import {
    KENDO_DIALOGS,
    KENDO_WINDOW,
    WindowCloseResult,
    WindowRef,
    WindowService,
} from '@progress/kendo-angular-dialog'
import { KENDO_INPUTS } from '@progress/kendo-angular-inputs'
import { SelectEvent, TabContentDirective, TabStripComponent, TabStripTabComponent } from '@progress/kendo-angular-layout'
import * as CryptoJS from 'crypto-js'
import { ToastrService } from 'ngx-toastr'
import { environment } from '../../../environments/environment'
import { InitUserService } from '../../@theme/services/init-user.service'
import { PDFSERVICE } from '../../@theme/services/pdfgetfiles.service'
import { TabServices } from '../../@theme/services/tab.service'
import { Filemanager2Component } from '../FileManager/filemanager2.component'
import { DialogService } from '../FileManager/service/btnbutton.service'
import { PDFLicenseViewerComponent } from '../Pdfviewer/content/licenseviewer/lice.component'
import { tabfilesCorrespondencelistComponent } from '../Pdfviewer/content/tabfileslist/tabfilesCorrespondencelist.component'
import { tabfilesOtherlistComponent } from '../Pdfviewer/content/tabfileslist/tabfilesOtherlist.component'
import { tabfilesTransactionlistComponent } from '../Pdfviewer/content/tabfileslist/tabfilesTransactionlist.component'
import { PDFViewerComponent } from '../Pdfviewer/pdfview.component'
import { TransactionsComponent } from '../Transactions/Transaction.component'
import { RVStep2TransactionFormComponent } from './step2Transactions/Rvstep2Transactions.component'
import { RVStep3NewAccountReviewComponent } from './step3Transactions/Rvstep3Newaccount.component'
import { tabfilesAccountpdflistComponent } from '../Pdfviewer/content/tabfileslist/tabfilesAccountpdflist.component'
import { FilemanagerComponent } from '../FileManager/filemanager.component'

@Component({
  selector: 'gd-tabsview',
  styleUrls: ['./tabs.component.css'],
  templateUrl: './tabs.component.html',
  imports: [
    NgIf,
    RouterLinkActive,
    TabStripComponent,
    TabStripTabComponent,
    TabContentDirective,
    TransactionsComponent,
    RVStep2TransactionFormComponent,
    RVStep3NewAccountReviewComponent,
    tabfilesAccountpdflistComponent,
    PDFLicenseViewerComponent,
    tabfilesTransactionlistComponent,
    tabfilesCorrespondencelistComponent,
    tabfilesOtherlistComponent,
    KENDO_WINDOW,
    KENDO_BUTTONS, KENDO_DIALOGS, KENDO_INPUTS,
    NgIcon

  ],
  providers: [
    provideIcons({ heroFolder })
  ]
})
export class TabsViewComponent implements OnInit {
  @Input() productId: string
  @Input() StatusTypeID: string
  @ViewChild('clientFilesComponent')
  clientFilesComponent!: tabfilesTransactionlistComponent
  clientfiles = true
  @ViewChild('correspFilesComponent')
  correspFilesComponent!: tabfilesCorrespondencelistComponent
  correspondfiles = true
  @ViewChild('otherFilesComponent')
  otherFilesComponent!: tabfilesOtherlistComponent
  otherfiles = true
  @ViewChild('accountFilesComponent')
  accountFilesComponent!: tabfilesOtherlistComponent
  accountfiles = true
  @ViewChild('step3Component')
  step3Component!: RVStep3NewAccountReviewComponent
  @ViewChild('step2Component')
  step2Component!: RVStep2TransactionFormComponent
  public service =
    'https://ej2services.syncfusion.com/production/web-services/api/pdfviewer'
  public document = 'PDF_Succinctly.pdf'
  pdfSrc: any
  public newAccount: boolean
  public hidetabmaintransid: boolean
  public loading = true
  public testback = 'what is up'
  public FilePath: string
  public selectedFormData: any
  public selectedFormDataviewer: Blob

  public viewallblot: boolean
  public opened2: boolean
  public windowRef: WindowRef
  public outquerystring: any
  public clientId: string
  public clientName: string
  public repId: string
  public ViewFileTrans: string
  public blotterId: string
  public spinnerload = false
  public selectedTab:
    | 'transaction'
    | 'review Summary'
    | 'account form review'
    | 'account form pdf'
    | 'drivers license' = 'transaction'
  public showReviewTransactionTab: boolean
  public showLicenseTab: boolean
  public showAccountFormPdfTab: boolean
  public showAccountFormReviewTab: boolean
  public showTransactionTab: boolean
  public reloadTransaction = true
  // Set when another tab saves; the Transaction tab refreshes once on next visit, then clears it.
  private transactionNeedsRefresh = false
  public accountFormReviewPending = true
  public licenseTabError: string | null = null
  public accountFormPdfTabError: string | null = null
  protected blotId: number
  private cnt3 = 0
  private rolecall: string

  constructor(
    private pdfService: PDFSERVICE,
    private rServ: TabServices,
    private toastrService: ToastrService,
    private route: ActivatedRoute,
    private router: Router,
    private dservice: DialogService,
    private windowService: WindowService,
    private cdr: ChangeDetectorRef,
    private initUserService: InitUserService,
  ) {
    const storageValueReturn =
      localStorage.getItem('rvarietylist') == undefined
        ? ''
        : localStorage.getItem('rvarietylist')
    const paramT = this.decryptProperty(storageValueReturn)
    const checkParamT = decodeURI(paramT)
    this.rolecall = checkParamT
    if (this.route.snapshot.queryParams) {
      this.route.queryParams.subscribe((params) => {
        this.showAccountFormReviewTab = params['accountformrvew'] === 'true'
        this.showReviewTransactionTab = params['reviewtrans'] === 'true'
        this.showTransactionTab = params['edittransactionShow'] === 'true'

        if (params['paramAccReview'] === 'Accountreview') {
          this.selectedTab = 'account form review'
        }
        if (params['EditTrans'] === 'true') {
          this.selectedTab = 'transaction'
        }
        if (params['edittransactionShow'] === 'true') {
          this.showTransactionTab = true
          if (params['accountformrvew'] === true) {
            this.showReviewTransactionTab === true
          }
          if (params['accountformrvew'] === true) {
            this.showAccountFormReviewTab === true
          }
        }
        if (params['ReviewShow'] === 'true') {
          this.route.queryParams.subscribe((params) => {
            const paramtransactiontype = this.decryptProperty(
              params['transaction'],
            )
            if (Number(paramtransactiontype) === 5) {
              this.selectedTab = 'account form review'
              this.showReviewTransactionTab = false
              this.showTransactionTab = true
              this.newAccount = false
            } else {
              this.selectedTab = 'review Summary'
              this.showReviewTransactionTab = true
              this.showTransactionTab = true
              this.newAccount = true
            }
          })
        }
        if (params['ReviewShow'] === undefined) {
          this.selectedTab = 'transaction'
        }
        if (params['paramAccReview'] === 'Accountreview') {
          this.selectedTab = 'account form review'
        }
      })
    }
    if (this.route.snapshot.queryParams['Rview']) {
      this.route.queryParams.subscribe((params) => {
        const getblotterClient = this.decryptProperty(params['Rview'])
        const paramclientname = this.decryptProperty(params['cl'])
        const paramstatustype = this.decryptProperty(params['statustype'])
        const paramtransactiontype = this.decryptProperty(params['transaction'])
        this.blotId = Number(getblotterClient)
        this.clientId = this.decryptProperty(params['clientId'])
        this.repId = this.decryptProperty(params['rId'])

        if (params['reviewtrans'].toString() === 'false') {
          this.showReviewTransactionTab = false
        }
        if (params['reviewtrans'].toString() === 'true') {
          this.showReviewTransactionTab = true
        }
        if (params['edittransactionShow'] !== undefined) {
          const bool2 =
            params['edittransactionShow'].toLowerCase() === 'true'
          if (bool2) {
            this.showTransactionTab = true

            if (params['reviewtrans'] !== undefined) {
              const bool1 = params['reviewtrans'].toLowerCase() === 'true'
              if (bool1) {
                this.showReviewTransactionTab = true
              } else {
                this.showReviewTransactionTab = false
              }
            }
            if (params['accountformrvew'] !== undefined) {
              const boolaccount =
                params['accountformrvew'].toLowerCase() === 'true'
              if (boolaccount) {
                this.showAccountFormReviewTab = true
              }
            }
            if (params['accountformrvew'] === false) {
              this.showAccountFormReviewTab = false
            }
          }
        }
        this.clientName = paramclientname.replace(/%20/g, '')
        if (
          Number(paramstatustype) >= 1 &&
          Number(paramtransactiontype) > 2 &&
          storageValueReturn.toUpperCase() === 'INSURANCE'.toUpperCase()
        ) {
          this.showReviewTransactionTab = false
          this.showLicenseTab = false
          this.showAccountFormPdfTab = false
          this.showAccountFormReviewTab = false
        }
      })
    }
    if (this.route.snapshot.queryParams['RviewAccount']) {
      this.route.queryParams.subscribe((params) => {
        const getblotterClient = CryptoJS.AES.decrypt(
          params['RviewAccount'],
          environment.securepw,
        ).toString(CryptoJS.enc.Utf8)
        const paramstatustype = CryptoJS.AES.decrypt(
          params['statustype'],
          environment.securepw,
        ).toString(CryptoJS.enc.Utf8)
        const paramtransactiontype = CryptoJS.AES.decrypt(
          params['transaction'],
          environment.securepw,
        ).toString(CryptoJS.enc.Utf8)
        this.blotId = Number(getblotterClient)
        this.clientId = CryptoJS.AES.decrypt(
          params['clientId'],
          environment.securepw,
        ).toString(CryptoJS.enc.Utf8)
        this.repId = CryptoJS.AES.decrypt(
          params['rId'],
          environment.securepw,
        ).toString(CryptoJS.enc.Utf8)
        if (params['edittransactionShow'] !== undefined) {
          const bool2 = params['edittransactionShow'].toLowerCase() === 'true'
          if (bool2) {
            this.showTransactionTab = true
            this.selectedTab = 'transaction'
            // this.TransactionShow = Boolean(params['edittransactionShow)
            this.correspondfiles = false
            this.otherfiles = false
            this.clientfiles = false
            if (params['reviewtrans'] !== undefined) {
              const bool1 = params['reviewtrans'].toLowerCase() === 'true'
              if (bool1) {
                this.showReviewTransactionTab = false
                this.correspondfiles = false
                this.otherfiles = false
                this.clientfiles = false
              }
            }
            if (params['accountformrvew'] !== undefined) {
              const boolaccount =
                params['accountformrvew'].toLowerCase() === 'true'
              if (boolaccount) {
                this.showAccountFormReviewTab = false
              }
            }
            if (params['accountformrvew'] === false) {
              this.showAccountFormReviewTab = false
            }
          }
        }
        // this.clientName = paramclientname.replace(/%20/g, '')
        if (
          Number(paramstatustype) >= 1 &&
          Number(paramtransactiontype) > 2 &&
          storageValueReturn.toUpperCase() === 'INSURANCE'.toUpperCase()
        ) {
          this.showReviewTransactionTab = false
          this.showLicenseTab = false
          this.showAccountFormPdfTab = false
          this.showAccountFormReviewTab = false
        }
      })
    }
    this.viewallblot = false
  }

  loaderstop(e: boolean) {
    this.loading = e
  }
  onTabSelect(e: SelectEvent): void {
    const title = (e?.title || '').trim()
    if (title === 'Transaction') {
      // Only refresh if another tab has saved since the Transaction tab was last shown.
      if (this.transactionNeedsRefresh) {
        this.transactionNeedsRefresh = false
        // Re-mount gd-addtrans so it re-runs its own data load (same idiom as reloadStep2).
        this.reloadTransaction = false
        this.cdr.detectChanges()
        setTimeout(() => {
          this.reloadTransaction = true
          this.cdr.detectChanges()
        }, 100)
      }
      return
    }
    // Review / Account Form Review load their own data once when first shown
    // (each self-loads on init, and keepTabContent preserves it afterwards), so
    // simply clicking back to a tab must NOT refetch — doing so wiped any
    // in-progress input. Saves still refresh in place via the submit handlers.
  }
  clientdata(_event: any): void {
    /* no-op: capture point for client selection if needed later */
  }
  onReviewApprovalStatus(approved: boolean) {
    this.accountFormReviewPending = !approved
  }
  onSubmit(event: any): void {
    this.spinnerload = true
    const param = {
      selectedValues: event,
      blotterId: this.blotId,
      role: this.rolecall,
    }
    // alert(JSON.stringify(param))
    this.rServ.SubmitReviewsData(param).subscribe({
      next: () => this.reviewDataSuccess(),
      error: () => this.reviewDataError(),
    })
  }
  reviewDataSuccess(): void {
    this.spinnerload = false
    this.toastrService.success('Your review data was saved successfully', 'Success')
    // After saving: Trading Principal stays on the page; every other role
    // redirects to the pending transactions screen (same as the Transaction save).
    if (!this.isTradingPrincipal()) {
      this.redirectAfterSave()
      return
    }
    // Trading Principal: reload the tab's data in place and stay on the page.
    if (this.step2Component) {
      this.step2Component.loadform(this.step2Component.paramsVal)
    }
    // Mark the Transaction tab stale so it refreshes once on next visit.
    this.transactionNeedsRefresh = true
  }
  private isTradingPrincipal(): boolean {
    return (this.rolecall || '').trim().toUpperCase() === 'TRADING PRINCIPAL'
  }
  private redirectAfterSave(): void {
    // Load the dashboard normally — clear both the one-shot blotter id and the
    // persisted pending view-state filter, otherwise the saved blotterId filter
    // keeps re-applying and the grid stays narrowed to a single transaction.
    sessionStorage.removeItem('blotterIdFiltered')
    // Clear only the transaction filter, keeping the user's selected view
    // button (Show All / Document Review / etc.).
    this.initUserService.clearPendingTransactionFilter()
    this.router.navigate(['/pages/dashboard'])
  }
  reviewDataError(): void {
    const duration = 2000
    this.spinnerload = false
    this.toastrService.error('Your review data was not saved', 'Error',)
  }
  onSubmitnewAcc(n: any) {
    const param = {
      selectedValues: n,
      blotterId: this.blotId,
      role: this.rolecall,
    }
    this.rServ.SubmitNewAccountData(param).subscribe({
      next: () => this.newAccountDataSuccess(),
      error: () => this.newAccountDataError(),
    })
  }
  newAccountDataSuccess(): void {
    this.spinnerload = false
    this.toastrService.success('New Account Review data saved successfully', 'Success')
    // After saving: Trading Principal stays on the page; every other role
    // redirects to the pending transactions screen (same as the Transaction save).
    if (!this.isTradingPrincipal()) {
      this.redirectAfterSave()
      return
    }
    // Trading Principal: reload the tab's data in place and stay on the page.
    if (this.step3Component) {
      this.step3Component.loadQuestions()
    }
    // Mark the Transaction tab stale so it refreshes once on next visit.
    this.transactionNeedsRefresh = true
  }
  newAccountDataError(): void {
    const duration = 2000
    this.spinnerload = false
    this.toastrService.error(
      'New Account Review data was not saved',
      'Error',

    )
  }
  onDialogClose() {
    this.dservice.emitCloseButtonClick()
    this.opened2 = false
  }
  close() {
    this.dservice.emitCloseButtonClick()
    this.opened2 = false
  }
  viewFilestransaction() {
    // If windowRef is not null, close the window before opening a new one
    if (this.windowRef) {
      this.windowRef.close()
    }

    this.viewallblot = false
    this.blotterId = this.blotId.toString()
    this.ViewFileTrans = this.blotId.toString()

    this.windowRef = this.windowService.open({
      title: 'File Manager',
      content: Filemanager2Component,
      width: 1000,
      height: 675,
    })

    const fileManager = this.windowRef.content.instance

    fileManager.outputClientId = this.clientId
    fileManager.outputrepId = this.repId
    fileManager.clientName = this.clientName
    fileManager.outquery = this.blotterId
    fileManager.viewallblot = this.viewallblot
    fileManager.blotterId = this.blotterId

    setTimeout(() => {
      fileManager.getFolderFiles()
    })

    // Sets windowRef to null when window is closed
    this.windowRef.result.subscribe((result) => {
      if (result instanceof WindowCloseResult) {
        this.windowRef = null
      }
    })
  }
  viewFilesaccount() {
    // If windowRef is not null, clodse the window before opening a new one
    if (this.windowRef) {
      this.windowRef.close()
    }

    this.viewallblot = true
    this.blotterId = this.blotId.toString()
    this.ViewFileTrans = ''

    this.windowRef = this.windowService.open({
      title: 'File Manager',
      content: Filemanager2Component,
      width: 1000,
      height: 675,
    })

    const fileManager = this.windowRef.content.instance

    fileManager.outputClientId = this.clientId
    fileManager.outputrepId = this.repId
    fileManager.clientName = this.clientName
    fileManager.outquery = this.blotterId
    fileManager.viewallblot = this.viewallblot
    fileManager.blotterId = this.blotterId

    setTimeout(() => {
      fileManager.getFolderFiles()
    })

    // Sets windowRef to null when window is closed
    this.windowRef.result.subscribe((result) => {
      if (result instanceof WindowCloseResult) {
        this.windowRef = null
      }
    })
  }
  ngOnInit(): void {
    setTimeout(() => {
      this.onTabSelectAccountFormCheck()
    }, 3000)
  }
  onTabSelectAccountFormCheck() {
    const param = {
      repId: Number(this.repId),
      clientId: Number(this.clientId),
      tabname: 'Account Forms',
    }
    if (this.cnt3 > 1) {
      // This allow only to hit the back end once.  Store in memmory
      return
    }
    this.pdfService.getPdfAccountForms(param).subscribe({
      next: (response) => {
        if (response && response.size > 0) {
          this.showAccountFormPdfTab = true
          this.selectedFormData = response
          this.accountFormPdfTabError = null
        } else {
          this.showAccountFormPdfTab = false
        }
        this.onTabSelectDriverlicenseCheck()
      },
      error: (error) => {
        console.error('Error loading Account Form PDF:', error)
        this.showAccountFormPdfTab = true
        this.accountFormPdfTabError = null
        this.onTabSelectDriverlicenseCheck()
      }
    })
    this.cnt3++
  }
  onTabSelectDriverlicenseCheck() {
    const param = {
      repId: Number(this.repId),
      clientId: Number(this.clientId),
      tabname: 'Drivers License',
    }
    this.pdfService.getPdfAccountForms(param).subscribe({
      next: (response) => {
        if (response && response.size > 0) {
          this.showLicenseTab = true
          this.selectedFormDataviewer = response
          this.licenseTabError = null
        } else {
          this.showLicenseTab = false
        }
      },
      error: (error) => {
        console.error('Error loading Drivers License:', error)
        this.showLicenseTab = true
        this.licenseTabError = 'Cannot view Drivers License because of corrupted file.'
      }
    })
  }
  onClientFilesChanged(value: boolean) {
    this.clientfiles = value
  }
  onCorresponFilesChanged(value: boolean) {
    this.correspondfiles = value
  }
  onOtherFilesChanged(value: boolean) {
    this.otherfiles = value
  }
onAccountFilesChanged(value: boolean) {
    this.accountfiles = value
  }
  private decryptProperty(value: string): string {
    const bytes = CryptoJS.AES.decrypt(value, environment.securepw);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);

    return decrypted
  }
}
